import React from 'react';
import styled from 'styled-components';
import { Intro } from './../Calculators/Intro';
import { ButtonPanel } from './../Calculators/ButtonPanel';
import { OneColumnLayout } from './../Calculators/Sections';
import { ChartSeries } from './ChartSeries';
import { TableSeries } from './TableSeries';
import { Button, ButtonLink } from './../Form/index';
import { HousePrice, RepaymentOptions } from './LeftPanel';
import { ClientLoan } from './ClientLoan';

const titleRepayment = [
  `Enter some details about your client\'s property and the repayments they might look
  to make to see the effect it could have on their loan and the equity in their home.`
];

const PartialRepayment = styled.div`
  h1 { text-align: center; color: #0a2f70; }
`;

export const PartialRepaymentComponent = ({ screen, partialRepayment, onChangeInput }) => {
  return (
    <PartialRepayment>
      <h1>Impact of making partial repayments on the cost of borrowing</h1>
      <Intro title={'Complete the fields below to see the impact making partial repayment has on the total cost of borrowing over time.'} padding={20} />
      {/*<Intro title={"The tool provides a guide only and figures are not guaranteed"} padding={20} />*/}

      <OneColumnLayout>
        <div className="sidebar">
          <ClientLoan {...partialRepayment} onChangeInput={onChangeInput} />
          <RepaymentOptions {...partialRepayment} onChangeInput={onChangeInput} />
          <div style={{ flex: 1, textAlign: 'center', fontSize: 20, paddingBottom: 16 }}>
            <strong>Looking to see how future house prices could affect the impact of partial repayments on the cost of borrowing? </strong><br/>Use the slider below to see the effect on the table
          </div>
          <HousePrice {...partialRepayment} onChangeInput={onChangeInput} />
        </div>
        <div className="content">
          {/*<DebugSeries series={partialRepayment.output.series} />*/}
          {/*<pre>{JSON.stringify(partialRepayment.input, null, 2)}</pre>*/}
          <ChartSeries {...partialRepayment.output} input={partialRepayment.input}/>
          <TableSeries {...partialRepayment.output} input={partialRepayment.input}/>
        </div>
      </OneColumnLayout>

      {screen.inFrame ? false : (
        <ButtonPanel className="footer">
          <ButtonLink to='/'>Back</ButtonLink>
          <div style={{ flex: 1 }}></div>
        </ButtonPanel>
      )}
    </PartialRepayment>
  );
};



// WEBPACK FOOTER //
// ./src/components/PartialRepayment/PartialRepaymentComponent.js